import React from "react";
import "./VideosRowItem.css";
import "./VideoPlayerItem.css";
import ReactHlsPlayer from 'react-hls-player';

const ItemDedicatedPageVOD = React.memo(props => {
  if(props.livestreamURLsByAuthUUID[props.authUUID].includes("m3u8")) {
    return (
      <ReactHlsPlayer
        className="videoItem-VideoImage"
        src={props.livestreamURLsByAuthUUID[props.authUUID]}
        onPlay={props.onVODPlay}
        controls={true}
        width="100%"
        height="auto"
        hlsConfig={{
          liveSyncDurationCount: 1
        }}
      />
    );
  } else {
    return (
      <video
        onPlay={props.onVODPlay}
        src={props.livestreamURLsByAuthUUID[props.authUUID]}
        controls
      >
      </video>
    );
  }
});

export default ItemDedicatedPageVOD;